// Also Consider carousel - added 2026-08-20.
//
// On mobile the related-products grid becomes a horizontal scroll-snap carousel
// (see the max-width: 749px block in assets/section-related-products.css). This
// script handles one thing: the nav arrows. It shows the prev arrow when there
// is something to the left and the next arrow when there is something to the
// right, and hides both entirely when the track is not scrolling horizontally
// at all - which is the case on desktop, where the grid still wraps normally.
//
// Deliberately no flash/pulse cue, unlike assets/cart-drawer-upsell-carousel.js.
//
// Everything is bound at the document level or via MutationObserver rather than
// to the elements themselves, for two reasons:
//
//   1. sections/related-products.liquid only emits the carousel markup when
//      recommendations.performed is true, which is only true on the
//      product_recommendations endpoint request. On the initial page load
//      <product-recommendations> is EMPTY - there is nothing to bind to.
//   2. ProductRecommendations in assets/global.js (~1566-1609) replaces its own
//      innerHTML once its IntersectionObserver fires, so any listener bound to
//      the markup that arrives would be discarded on the next re-render, and
//      the theme editor replaces the whole custom element on section reload.

(function () {
	const TRACK = '.related-products .product-grid'
	const CAROUSEL = '.related-products__carousel'
	const NAV = '.related-products__nav'
	const PREV = '.related-products__nav--prev'
	const NEXT = '.related-products__nav--next'
	const SLIDE = '.grid__item'
	const EDGE = 2 // px tolerance, sub-pixel scroll positions never land on 0

	const observed = new WeakSet()

	function updateNav(track) {
		const wrapper = track.closest(CAROUSEL)
		if (!wrapper) return

		const prev = wrapper.querySelector(PREV)
		const next = wrapper.querySelector(NEXT)
		const maxScroll = track.scrollWidth - track.clientWidth
		const scrollable = maxScroll > EDGE

		if (prev) prev.hidden = !scrollable || track.scrollLeft <= EDGE
		if (next) next.hidden = !scrollable || track.scrollLeft >= maxScroll - EDGE
	}

	function updateAll() {
		document.querySelectorAll(TRACK).forEach(updateNav)
	}

	function step(track) {
		const slide = track.querySelector(SLIDE)
		if (!slide) return track.clientWidth
		const gap = parseFloat(getComputedStyle(track).columnGap) || 0
		return slide.getBoundingClientRect().width + gap
	}

	document.addEventListener('click', function (event) {
		const button = event.target.closest && event.target.closest(NAV)
		if (!button) return
		event.preventDefault()

		const wrapper = button.closest(CAROUSEL)
		const track = wrapper && wrapper.querySelector('.product-grid')
		if (!track) return

		const back = button.classList.contains('related-products__nav--prev')
		track.scrollBy({ left: back ? -step(track) : step(track), behavior: 'smooth' })
	})

	// scroll does not bubble, so listen in the capture phase
	document.addEventListener(
		'scroll',
		function (event) {
			const target = event.target
			if (target instanceof Element && target.matches(TRACK)) updateNav(target)
		},
		true
	)

	// <product-recommendations> keeps its identity and swaps its children, so
	// observing the element itself catches the render that matters. Only
	// childList/subtree is observed, so the [hidden] attributes this script sets
	// cannot retrigger it. The WeakSet stops a second observer being attached to
	// an element that already has one.
	function attach() {
		if (!window.MutationObserver) return
		document.querySelectorAll('product-recommendations').forEach(function (element) {
			if (observed.has(element)) return
			observed.add(element)
			new MutationObserver(updateAll).observe(element, {
				childList: true,
				subtree: true,
			})
		})
	}

	function refresh() {
		attach()
		updateAll()
	}

	window.addEventListener('resize', updateAll)
	document.addEventListener('DOMContentLoaded', refresh)
	// the theme editor replaces the whole section, giving a new custom element
	document.addEventListener('shopify:section:load', refresh)
	refresh()
})()
